import { chakra } from '@stockx/ui';

export const MenuWrapper = chakra('div', {
  baseStyle: {
    position: 'relative',
    height: '100%',
  },
});

export const MenuContainer = chakra('div', {
  baseStyle: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: '-100%',
    overflowY: 'scroll',
    backgroundColor: 'neutral.white',
    transition: 'all 0.3s linear',

    '&.visible': {
      left: 0,
    },

    '&.submenu-visible': {
      overflowY: 'auto',
    },
  },
});
